export default "__VITE_ASSET__3W89K0KC__"